import React, {Component} from 'react';
import './railwayreportwidget.css';
import _ from 'lodash';
import moment from 'moment';
import { format, roundNumber, duration } from './railwaysReport';

let Loading = () => {
    return <div className="rrw-spinner"></div>
}

export function getColValues(r, i) {
    let fmt = 'HH:mm';    
    let dis = roundNumber(r.distance);
    let dur = r.timetaken;
    let maxspd = roundNumber(r.maxspeed);
    let avgspd = roundNumber(r.avgspeed);
    let colorCodedTimeColumn = (time, status) => {
        return (props) => {
            let title = time ? moment(time).format(format) : '';
            let cls = '';
            if(status) cls = status === 'DELAYED' ? '-r' : '-g';
            return <span className={cls} title={title}>
                {props.children}
            </span>
        }
    }
    return [
        [i + 1],
        [r.stationname + (r.stationcode ? ' (' + r.stationcode + ')' : '')],
        [r.exparrtime ? moment(r.exparrtime).format(fmt) : '--:--', (props) => <span title={moment(r.exparrtime).format(format)}>{props.children}</span>],
        [r.arrivedat ? moment(r.arrivedat).format(fmt) : '--:--', colorCodedTimeColumn(r.arrivedat, r.arrstatus)],
        [r.expdeptime ? moment(r.expdeptime).format(fmt) : '--:--', (props) => <span title={moment(r.expdeptime).format(format)}>{props.children}</span>],
        [r.depat ? moment(r.depat).format(fmt) : '--:--', colorCodedTimeColumn(r.depat, r.depstatus)],
        [duration(dur)],
        [dis],
        [maxspd],
        [avgspd],
        [r.arrstatus, (props) => <span className={r.arrstatus === 'DELAYED' ? '-r' : '-g'}>{props.children}</span>],
        [duration(r.arrtimediff)],
    ]
}

export default class RailwayReportWidget extends Component {
    state = {
        index: '',
        items: [],
        busy: false,
    }
    setBusy = (busy) => {
        this.setState({busy: true});
    }
    setData = (items) => {
        this.setState({items, busy: false});
    }
    getData = () => {
        return this.state.items;
    }
    render() {
        let items = this.state.items;
        let renderItem = (item, idx) => {
            let trainno = item.vehicleno;
            let trainname = item.trainname;
            let dis = roundNumber(item.distance);
            let dur = item.timetaken;
            let maxspd = roundNumber(item.maxspeed);
            let avgspd = roundNumber(item.avgspeed);
            let expand = () => {
                this.setState({index: this.state.index === idx ? '' : idx});
            }
            let start = item.stations[0];
            let dest = _.last(item.stations);
            return <div className="rrwi" key={idx}>
                <div className="rrwh" onClick={expand}>
                    <div className="rrwha">
                        <div className="rrwhab">{trainname || 'N/A'}</div>
                        <div className="rrwhac">TRAIN NO</div>
                        <div className="rrwhaa">{trainno}</div>
                    </div>
                    <div className="rrwhb">
                        <div className="rrwhba">Expected</div>
                        <div className="rrwhbb">Actual</div>
                    </div>
                    <div className="rrwhc">
                        <div className="rrwhcb">{start.stationname} {start.stationcode ? '(' + start.stationcode + ')' : null}</div>
                        <div className="rrwhca">{moment(item.expstarttime).format(format)}</div>
                        <div className="rrwhcc">{moment(item.starttime).format(format)}</div>
                    </div>
                    <div className="rrwhd">
                        <i className="fa fa-arrow-right"></i>
                    </div>
                    <div className="rrwhc">
                        <div className="rrwhcb">{dest.stationname} {dest.stationcode ? '(' + dest.stationcode + ')' : null}</div>
                        <div className="rrwhca">{moment(item.expendtime).format(format)}</div>
                        <div className="rrwhcc">{moment(item.endtime).format(format)}</div>
                    </div>
                    <div className="rrwhe">
                        <div className="rrwhea">Duration</div>
                        <div className="rrwheb">{duration(dur)}</div>
                    </div>
                    <div className="rrwhe">
                        <div className="rrwhea">Distance</div>
                        <div className="rrwheb"><span>{dis}</span>kms</div>
                    </div>
                    <div className="rrwhe">
                        <div className="rrwhea">Max Speed</div>
                        <div className="rrwheb"><span>{maxspd}</span>kmph</div>
                    </div>
                    <div className="rrwhe">
                        <div className="rrwhea">Avg Speed</div>
                        <div className="rrwheb"><span>{avgspd}</span>kmph</div>
                    </div>
                    <div className={'rrwhe ' + (item.trainstatus === 'DELAYED' ? '-r' : '-g')}>
                        <div className="rrwhea">{item.trainstatus}</div>
                        <div className="rrwheb">{duration(item.statustime)}</div>
                    </div>
                </div>
                <div className={'rrwb' + (this.state.index === idx ? ' open' : '')}>
                    <table>
                        <thead>
                            <tr>
                                <th rowSpan={2}>Sr.</th>
                                <th rowSpan={2}>Station Name</th>
                                <th colSpan={2}>Arrival Time</th>
                                <th colSpan={2}>Departure Time</th>
                                <th rowSpan={2}>Duration<br /><span>(hrs)</span></th>
                                <th rowSpan={2}>Distance<br /><span>(kms)</span></th>
                                <th rowSpan={2}>Max Speed<br /><span>(kmph)</span></th>
                                <th rowSpan={2}>Avg Speed<br /><span>(kmph)</span></th>
                                <th rowSpan={2}>Arrival<br />Status</th>
                                <th rowSpan={2}>Arrival<br />Time Diff</th>
                            </tr>
                            <tr>
                                <th>Expected</th>
                                <th>Actual</th>
                                <th>Expected</th>
                                <th>Actual</th>
                            </tr>
                        </thead>
                        <tbody>
                            {item.stations.map((r, i) => {
                                return <tr key={i}>
                                    {getColValues(r, i).map((c, i) => {
                                        let content = c[0];
                                        let Wrap = c[1];
                                        if(Wrap) content = <Wrap>{content}</Wrap>;
                                        return <td key={i}>{content}</td>
                                    })}
                                </tr>
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        }
        return (
            <div className="rrw">
                {!this.state.busy && <div className="rrwa">
                    {items.map(renderItem)}
                </div>}
                {items.length === 0 && !this.state.busy && <div className="rrwc">No Data</div>}
                {this.state.busy && <Loading />}
            </div>
        )
    }
}